import { createIcon } from "@chakra-ui/react";

export const GlobeIcon = createIcon({
  displayName: "GlobeIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      fill="currentColor"
      d="M17.239 14.423h4.056q0.338-1.577 0.338-2.423t-0.338-2.423h-4.056q0.169 1.183 0.169 2.423t-0.169 2.423zM15.099 21.070q1.408-0.451 2.93-1.718t2.31-2.563h-3.549q-0.563 2.254-1.69 4.282zM14.817 14.423q0.169-1.183 0.169-2.423t-0.169-2.423h-5.634q-0.169 1.183-0.169 2.423t0.169 2.423h5.634zM12 21.577q1.577-2.31 2.31-4.789h-4.62q0.732 2.479 2.31 4.789zM7.211 7.211q0.676-2.423 1.69-4.282-1.408 0.451-2.958 1.718t-2.282 2.563h3.549zM3.662 16.789q0.732 1.296 2.282 2.563t2.958 1.718q-1.127-2.028-1.69-4.282h-3.549zM2.704 14.423h4.056q-0.169-1.183-0.169-2.423t0.169-2.423h-4.056q-0.338 1.577-0.338 2.423t0.338 2.423zM12 2.423q-1.577 2.31-2.31 4.789h4.62q-0.732-2.479-2.31-4.789zM20.338 7.211q-0.789-1.296-2.31-2.563t-2.93-1.718q1.014 1.859 1.69 4.282h3.549zM12 0q4.958 0 8.479 3.521t3.521 8.479-3.521 8.479-8.479 3.521-8.479-3.521-3.521-8.479 3.521-8.479 8.479-3.521z"
    />
  ),
});

export const QuoteIcon = createIcon({
  displayName: "QuoteIcon",
  viewBox: "0 0 42 32",
  path: (
    <g fill="currentColor">
      <path d="M0.009 25.422v-1.538c0.307 0.281 0.642 0 0.868-0.173-0.078-0.221-0.222-0.377-0.299-0.598-0.413-0.019-0.496 0.292-0.569 0.614v-4.079c0.025 0.033 0.051 0.072 0.074 0.111l0.003 0.006c0.014 0.022 0.032 0.041 0.043 0.064 0.038-0.017 0.070-0.038 0.098-0.064l-0 0c0.239-0.209 0.285-0.732-0.218-0.683v-5.734h7.7v-1.372c0-0.016 0-0.035 0-0.054 0-2.807-2.276-5.083-5.083-5.083-0.078 0-0.155 0.002-0.232 0.005l0.011-0h-2.396v-6.844h4.963c7.87 0 13.859 4.448 13.859 12.144v19.851h-18.821zM2.52 5.636c-0.391-0.042-0.642 0.055-0.598 0.448 0.39 0.042 0.747 0.050 0.598-0.448zM5.507 22.367c0.67-0.007 0.027-0.793 0-1.051h-1.045c0.176 0.526 1.256 0.142 1.045 1.051zM6.254 22.367c0.3 0.206 0.652 0.362 1.031 0.445l0.020 0.004c-0.316-0.565-0.638-0.323-1.051-0.897 0.104 0.12 0.232 0.404 0 0.448zM7.305 21.316c-0.028-0.42-0.259-0.636-0.746-0.597-0.016 0.076-0.026 0.164-0.026 0.254 0 0.237 0.065 0.458 0.178 0.647l-0.003-0.006c0.215-0.074 0.37-0.216 0.591-0.294zM8.501 21.914c0.544-0.459-0.678-0.409-0.747-0.747-0.608 0.522 0.777 0.308 0.741 0.752zM7.604 22.213v0.746c0.213-0.013 0.423-0.025 0.448 0.149 0.246-0.114 0.012-0.997-0.454-0.891zM11.638 21.765c0.208 0.434 0.737-0.042 0.897-0.149-0.132-0.343-0.661 0.124-0.903 0.154zM14.775 24.451c0.39 0.042 0.642-0.055 0.597-0.448-0.262-0.262-0.593 0.054-0.603 0.457zM0.136 18.028v0.299h0.747c0.147-0.495-0.471-0.225-0.753-0.292zM1.629 17.58c0.192-0.208 0.701-0.091 0.897-0.299-0.159-0.329-1.007-0.111-0.903 0.306zM4.019 19.223c0.27 0.234 0.458 0.538 1.051 0.448-0.037-0.465-0.601-0.398-1.059-0.441zM5.214 16.086c-0.304 0.209 0.147 0.515-0.149 0.896 0.242 0.042 0.258-0.14 0.448-0.148 0.123-0.466-0.241-0.455-0.305-0.74zM7.455 1.147c0.297 0.25 0.19-0.013 0.598 0 0.010-0.030 0.016-0.064 0.016-0.099 0-0.176-0.143-0.319-0.319-0.319s-0.319 0.143-0.319 0.319c0 0.038 0.007 0.074 0.019 0.108l-0.001-0.002zM8.202 12.358c-0.37 0.334 0.486 0.893 0.746 0.597-0.329-0.123-0.338-0.557-0.752-0.596zM10.443 12.954c-0.424-0.025-0.292 0.506-0.897 0.299 0.249 0.3 0.402 0.701 0.897 0.747 0.095-0.145 0.034-1.038 0.299-0.299 0.579-0.137-0.096-0.536-0.308-0.746zM13.43 10.565c0.022 0.326 0.377 0.32 0.747 0.298-0.057-0.525-0.398-0.384-0.753-0.297zM13.879 19.527c0.487 0.039 0.719-0.177 0.747-0.598-0.361 0.095-0.702 0.202-0.753 0.599zM15.919 19.761c-0.146 0.257-0.44 0.366-0.397 0.817h0.448c0.262-0.25-0.070-0.37-0.012-0.817 0-0.028 0-0.054 0.012-0.085-0.017 0.033-0.036 0.062-0.058 0.089l0.001-0.001zM16.418 19.676c0.011 0.033 0.026 0.061 0.045 0.086l-0-0.001c0.081 0.125 0.224 0.187 0.253 0.363 0.265-0.042 0.312-0.214 0.257-0.363-0.033-0.136-0.153-0.235-0.297-0.235-0.112 0-0.21 0.061-0.263 0.151l-0.001 0.001zM6.259 25.801c0.005-0.035 0.008-0.075 0.008-0.115 0-0.095-0.016-0.186-0.045-0.271l0.002 0.006c-0.055-0.154-0.175-0.244-0.413-0.217-0.038 0.062-0.067 0.135-0.082 0.213l-0.001 0.004c0.004 0.038 0.007 0.082 0.007 0.126 0 0.145-0.027 0.284-0.076 0.412l0.003-0.008c0.307 0.065 0.391-0.1 0.593-0.147z"></path>
      <path d="M26.569 31.33c-0.46-0.14-0.276 0.363-0.292 0.667h-2.655v-18.65h7.699v-1.37c0-0.004 0-0.009 0-0.014 0-2.833-2.297-5.13-5.13-5.13-0.121 0-0.241 0.004-0.361 0.012l0.016-0.001h-2.225v-6.844h4.962c0.048-0 0.105-0.001 0.162-0.001 2.114 0 4.139 0.38 6.010 1.077l-0.119-0.039c-0.102 0.569 0.613 0.71 0.746 0.295 1.232 0.545 2.292 1.235 3.222 2.067l-0.012-0.010c-0.029-0.008-0.062-0.013-0.097-0.013-0.204 0-0.369 0.165-0.369 0.369 0 0.095 0.036 0.182 0.096 0.248l-0-0c0.368 0.042 0.385-0.267 0.437-0.541 1.763 1.62 2.988 3.801 3.393 6.258l0.009 0.063c-0.068 0.047-0.153 0.076-0.244 0.076-0.057 0-0.112-0.011-0.162-0.031l0.003 0.001c0.184 0.062 0.339 0.171 0.455 0.314l0.001 0.002c0.096 0.602 0.153 1.3 0.158 2.010l0 0.004v19.851h-15.666c0.175-0.194 0.197-0.59-0.036-0.67zM28.809 3.694c-0.535-0.086-0.454 0.443-0.448 0.897h0.448zM29.86 18.633c-0.364 0.084-0.768 0.127-0.747 0.597 0.433-0.011 0.838-0.054 0.743-0.597zM32.25 17.288c0.558 0.441 0.174 0.605 0.298 1.051 0.543 0.044 0.2-0.796 0.448-1.051-0.099-0.090-0.23-0.146-0.375-0.146s-0.277 0.055-0.376 0.146l0-0zM33.744 1.304c0.067 0.133 0.131 0.267 0.299 0.299-0.119 0.134-0.27 0.237-0.441 0.297l-0.007 0.002c0.26 1.024 1.183-0.789 0.145-0.598zM36.88 2.947c0.28 0.081 0.766 0.713 1.051 0.299 0.11-0.568-0.716-0.19-1.056-0.299zM40.914 14.749c-0.624 0.099-0.069 0.927 0.299 0.447-0.057-0.196-0.267-0.23-0.308-0.447zM40.914 18.035c0.364-0.084 0.768-0.128 0.747-0.598-0.22 0.234-0.784 0.118-0.757 0.598zM24.93 22.218c-0.564-0.217-0.286 0.41-0.746 0.299 0.204 0.392 0.628 0.566 0.746 1.045 0.385-0.257-0.215-0.772-0.005-1.344zM30.905 21.77q0.701 0.105 0.598-0.598c-0.174 0.025-0.266-0.033-0.299-0.149-0.193 0.134-0.318 0.354-0.318 0.603 0 0.051 0.005 0.101 0.015 0.149l-0.001-0.005zM40.168 28.343c0.399-0.056 0.701-0.794 0-0.747-0.051 0.111-0.081 0.242-0.081 0.379 0 0.133 0.028 0.26 0.079 0.374l-0.002-0.006zM40.764 29.388c0.040-0.487-0.178-0.719-0.597-0.746 0 0.145-0.183 0.117-0.299 0.149 0 0.492 0.419 0.571 0.891 0.597zM29.113 25.504c0 0 0.001 0 0.001 0 0.050 0 0.091-0.035 0.102-0.081l0-0.001c0.025-0.063 0.026-0.148 0.046-0.217 0.023-0.277 0.506-0.091 0.598-0.299-0.078-0.221-0.221-0.376-0.299-0.597-0.423-0.124-0.387 0.21-0.747 0.149 0.142 0.28 0.243 0.606 0.284 0.95l0.001 0.014c0 0.029 0.003 0.054 0.012 0.082z"></path>
    </g>
  ),
});

export const LocationIcon = createIcon({
  displayName: "LocationIcon",
  viewBox: "0 0 22 32",
  path: (
    <path
      fill="currentColor"
      d="M11.2 0c-0.003 0-0.006 0-0.009 0-6.181 0-11.191 5.011-11.191 11.191 0 0.003 0 0.006 0 0.009v-0.001c0 8.4 11.2 20.8 11.2 20.8s11.2-12.403 11.2-20.8c0-0.003 0-0.006 0-0.009 0-6.181-5.011-11.191-11.191-11.191-0.003 0-0.006 0-0.009 0h0.001zM11.2 15.2c-2.209 0-3.999-1.791-3.999-3.999s1.791-3.999 3.999-3.999c2.209 0 3.999 1.791 3.999 3.999v0c-0.001 2.209-1.791 3.999-3.999 3.999h-0z"
    ></path>
  ),
});

export const InstagramIcon = createIcon({
  displayName: "InstagramIcon",
  viewBox: "0 0 24 28",
  path: (
    <path
      fill="currentColor"
      d="M16 14c0-2.203-1.797-4-4-4s-4 1.797-4 4 1.797 4 4 4 4-1.797 4-4zM18.156 14c0 3.406-2.75 6.156-6.156 6.156s-6.156-2.75-6.156-6.156 2.75-6.156 6.156-6.156 6.156 2.75 6.156 6.156zM19.844 7.594c0 0.797-0.641 1.437-1.437 1.437s-1.437-0.641-1.437-1.437 0.641-1.437 1.437-1.437 1.437 0.641 1.437 1.437zM12 4.156c-1.75 0-5.5-0.141-7.078 0.484-0.547 0.219-0.953 0.484-1.375 0.906s-0.688 0.828-0.906 1.375c-0.625 1.578-0.484 5.328-0.484 7.078s-0.141 5.5 0.484 7.078c0.219 0.547 0.484 0.953 0.906 1.375s0.828 0.688 1.375 0.906c1.578 0.625 5.328 0.484 7.078 0.484s5.5 0.141 7.078-0.484c0.547-0.219 0.953-0.484 1.375-0.906s0.688-0.828 0.906-1.375c0.625-1.578 0.484-5.328 0.484-7.078s0.141-5.5-0.484-7.078c-0.219-0.547-0.484-0.953-0.906-1.375s-0.828-0.688-1.375-0.906c-1.578-0.625-5.328-0.484-7.078-0.484zM24 14c0 1.656 0.016 3.297-0.078 4.953-0.094 1.922-0.531 3.625-1.937 5.031s-3.109 1.844-5.031 1.937c-1.656 0.094-3.297 0.078-4.953 0.078s-3.297 0.016-4.953-0.078c-1.922-0.094-3.625-0.531-5.031-1.937s-1.844-3.109-1.937-5.031c-0.094-1.656-0.078-3.297-0.078-4.953s-0.016-3.297 0.078-4.953c0.094-1.922 0.531-3.625 1.937-5.031s3.109-1.844 5.031-1.937c1.656-0.094 3.297-0.078 4.953-0.078s3.297-0.016 4.953 0.078c1.922 0.094 3.625 0.531 5.031 1.937s1.844 3.109 1.937 5.031c0.094 1.656 0.078 3.297 0.078 4.953z"
    ></path>
  ),
});

export const TwitterIcon = createIcon({
  displayName: "TwitterIcon",
  viewBox: "0 0 26 28",
  path: (
    <path
      fill="currentColor"
      d="M25.312 6.375c-0.688 1-1.547 1.891-2.531 2.609 0.016 0.219 0.016 0.438 0.016 0.656 0 6.672-5.078 14.359-14.359 14.359-2.859 0-5.516-0.828-7.75-2.266 0.406 0.047 0.797 0.063 1.219 0.063 2.359 0 4.531-0.797 6.266-2.156-2.219-0.047-4.078-1.5-4.719-3.5 0.313 0.047 0.625 0.078 0.953 0.078 0.453 0 0.906-0.063 1.328-0.172-2.312-0.469-4.047-2.5-4.047-4.953v-0.063c0.672 0.375 1.453 0.609 2.281 0.641-1.359-0.906-2.25-2.453-2.25-4.203 0-0.938 0.25-1.797 0.688-2.547 2.484 3.062 6.219 5.063 10.406 5.281-0.078-0.375-0.125-0.766-0.125-1.156 0-2.781 2.25-5.047 5.047-5.047 1.453 0 2.766 0.609 3.687 1.594 1.141-0.219 2.234-0.641 3.203-1.219-0.375 1.172-1.172 2.156-2.219 2.781 1.016-0.109 2-0.391 2.906-0.781z"
    ></path>
  ),
});

export const LinkedInIcon = createIcon({
  displayName: "LinkedInIcon",
  viewBox: "0 0 24 28",
  path: (
    <path
      fill="currentColor"
      d="M5.453 9.766v15.484h-5.156v-15.484h5.156zM5.781 4.984c0.016 1.484-1.109 2.672-2.906 2.672v0h-0.031c-1.734 0-2.844-1.188-2.844-2.672 0-1.516 1.156-2.672 2.906-2.672 1.766 0 2.859 1.156 2.875 2.672zM24 16.375v8.875h-5.141v-8.281c0-2.078-0.75-3.5-2.609-3.5-1.422 0-2.266 0.953-2.641 1.875-0.125 0.344-0.172 0.797-0.172 1.266v8.641h-5.141c0.063-14.031 0-15.484 0-15.484h5.141v2.25h-0.031c0.672-1.062 1.891-2.609 4.672-2.609 3.391 0 5.922 2.219 5.922 6.969z"
    ></path>
  ),
});

export const FacebookIcon = createIcon({
  displayName: "FacebookIcon",
  viewBox: "0 0 16 28",
  path: (
    <path
      fill="currentColor"
      d="M14.984 0.187v4.125h-2.453c-1.922 0-2.281 0.922-2.281 2.25v2.953h4.578l-0.609 4.625h-3.969v11.859h-4.781v-11.859h-3.984v-4.625h3.984v-3.406c0-3.953 2.422-6.109 5.953-6.109 1.687 0 3.141 0.125 3.563 0.187z"
    ></path>
  ),
});

export const VisionIcon = createIcon({
  displayName: "VisionIcon",
  viewBox: "0 0 32 32",
  path: (
    <g>
      <path
        fill="#8ba58f"
        opacity="0.24"
        d="M1.067 0h29.867c0.589 0 1.067 0.478 1.067 1.067v0 29.867c0 0.589-0.478 1.067-1.067 1.067v0 0c-17.084 0-30.933-13.849-30.933-30.933v0 0c0-0.589 0.478-1.067 1.067-1.067v0z"
      ></path>
      <path
        fill="currentColor"
        d="M1.067 0v0c17.084 0 30.933 13.849 30.933 30.933v0 0c0 0.589-0.478 1.067-1.067 1.067v0h-29.867c-0.589 0-1.067-0.478-1.067-1.067v0-29.867c0-0.589 0.478-1.067 1.067-1.067v0z"
      ></path>
      <path
        fill="#fff"
        d="M24.857 16.751c-1.435-1.749-4.474-3.789-7.79-3.789-3.328 0-6.367 2.054-7.79 3.789-0.066 0.079-0.105 0.182-0.105 0.295s0.040 0.215 0.106 0.295l-0.001-0.001c1.469 1.791 4.516 3.789 7.79 3.789 3.392 0 6.417-2.117 7.79-3.789 0.066-0.079 0.105-0.182 0.105-0.295s-0.040-0.215-0.106-0.295l0.001 0.001zM20.221 17.045c0 1.742-1.412 3.155-3.155 3.155s-3.155-1.412-3.155-3.155c0-1.742 1.412-3.155 3.155-3.155v0c1.742 0.002 3.153 1.413 3.155 3.155v0zM10.263 17.045c0.99-1.021 2.169-1.853 3.481-2.44l0.071-0.028c-0.52 0.677-0.833 1.536-0.833 2.468s0.313 1.791 0.84 2.478l-0.007-0.010c-1.385-0.61-2.565-1.442-3.549-2.464l-0.003-0.003zM20.318 19.514c0.52-0.677 0.833-1.536 0.833-2.468s-0.313-1.791-0.84-2.478l0.007 0.010c1.385 0.61 2.565 1.442 3.549 2.464l0.003 0.003c-0.99 1.021-2.169 1.853-3.481 2.439l-0.071 0.028z"
      ></path>
      <path
        fill="#fff"
        d="M15.488 17.045c0 0.872 0.707 1.579 1.579 1.579s1.579-0.707 1.579-1.579c0-0.872-0.707-1.579-1.579-1.579v0c-0.872 0.001-1.578 0.707-1.579 1.579v0zM17.717 17.045c0 0.359-0.291 0.65-0.65 0.65s-0.65-0.291-0.65-0.65c0-0.359 0.291-0.65 0.65-0.65v0c0.359 0 0.65 0.291 0.65 0.65v0z"
      ></path>
      <path
        fill="#fff"
        d="M17.067 11.162c0.256 0 0.464-0.208 0.464-0.464v0-1.084c0-0.256-0.208-0.464-0.464-0.464s-0.464 0.208-0.464 0.464v0 1.084c0 0.256 0.208 0.464 0.464 0.464v0z"
      ></path>
      <path
        fill="#fff"
        d="M19.838 11.783c0.066 0.038 0.145 0.061 0.23 0.061 0.172 0 0.322-0.093 0.402-0.232l0.001-0.002 0.618-1.084c0.038-0.066 0.061-0.145 0.061-0.23 0-0.256-0.208-0.464-0.464-0.464-0.172 0-0.322 0.093-0.402 0.232l-0.001 0.002-0.619 1.084c-0.038 0.066-0.061 0.145-0.061 0.23 0 0.172 0.094 0.322 0.233 0.402l0.002 0.001z"
      ></path>
      <path
        fill="#fff"
        d="M13.662 11.61c0.082 0.141 0.232 0.234 0.403 0.234 0.256 0 0.464-0.208 0.464-0.464 0-0.085-0.023-0.164-0.062-0.232l0.001 0.002-0.618-1.084c-0.082-0.141-0.232-0.234-0.403-0.234-0.256 0-0.464 0.208-0.464 0.464 0 0.085 0.023 0.164 0.062 0.232l-0.001-0.002z"
      ></path>
      <path
        fill="#fff"
        d="M17.067 22.928c-0.256 0-0.464 0.208-0.464 0.464v0 1.084c0 0.256 0.208 0.464 0.464 0.464s0.464-0.208 0.464-0.464v-1.084c0-0.256-0.208-0.464-0.464-0.464v0z"
      ></path>
      <path
        fill="#fff"
        d="M14.297 22.307c-0.066-0.038-0.145-0.061-0.23-0.061-0.172 0-0.322 0.093-0.402 0.232l-0.001 0.002-0.618 1.084c-0.038 0.066-0.061 0.145-0.061 0.23 0 0.256 0.208 0.464 0.464 0.464 0.172 0 0.322-0.093 0.402-0.232l0.001-0.002 0.618-1.084c0.038-0.066 0.061-0.146 0.061-0.23 0-0.172-0.093-0.322-0.232-0.402l-0.002-0.001z"
      ></path>
    </g>
  ),
});

export const BeneficiariesIcon = createIcon({
  displayName: "BeneficiariesIcon",
  viewBox: "0 0 90 90",
  path: [
    <defs>
      <clipPath id="clip-path">
        <rect width="90" height="90" fill="none" />
      </clipPath>
    </defs>,
    <g id="icon">
      <g
        id="Repeat_Grid_3"
        data-name="Repeat Grid 3"
        clip-path="url(#clip-path)"
      >
        <path
          id="Rectangle_2342"
          data-name="Rectangle 2342"
          d="M3,0H87a3,3,0,0,1,3,3V87a3,3,0,0,1-3,3h0A87,87,0,0,1,0,3V3A3,3,0,0,1,3,0Z"
          fill="#8ba58f"
          opacity="0.24"
        />
      </g>
      <path
        id="Rectangle_2343"
        data-name="Rectangle 2343"
        d="M3,0H3A87,87,0,0,1,90,87v0a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0Z"
        fill="currentColor"
      />
    </g>,
    <g
      id="Group_39583"
      data-name="Group 39583"
      transform="translate(-1017 -4478.615)"
    >
      <g id="Layer_x0020_1" transform="translate(1041 4500)">
        <path
          id="Path_19691"
          data-name="Path 19691"
          d="M18.615,45.908a7.975,7.975,0,0,1,6.957,9.365h7.486a9.019,9.019,0,0,1,16.509,0H51.5V32.524H18.615ZM36.79,59.31A1.134,1.134,0,0,1,38.709,58.1l1.112,1.762,4.224-4.544a1.134,1.134,0,0,1,1.661,1.546L40.48,62.488a1.136,1.136,0,0,1-1.79-.169ZM34.57,58.9a6.742,6.742,0,1,0,6.742-6.742A6.742,6.742,0,0,0,34.57,58.9ZM32.4,57.546H24.783a7.992,7.992,0,0,1-1.273,1.77,9.479,9.479,0,0,1,3.7,7.5v5.4a1.136,1.136,0,0,1-1.137,1.137H9.4A1.136,1.136,0,0,1,8.26,72.215v-5.4a9.478,9.478,0,0,1,3.7-7.5,7.968,7.968,0,0,1,4.38-13.336V31.387a1.137,1.137,0,0,1,1.137-1.137H52.637a1.137,1.137,0,0,1,1.137,1.137V56.41a1.136,1.136,0,0,1-1.137,1.137h-2.41a9.016,9.016,0,1,1-17.828,0Zm6.025-18.489a1.137,1.137,0,0,1,0-2.274H45.47a1.137,1.137,0,0,1,0,2.274Zm0,4.751a1.137,1.137,0,0,1,0-2.274H45.47a1.137,1.137,0,0,1,0,2.274ZM24.644,35.556h9.463a1.137,1.137,0,0,1,1.137,1.137V43.9a1.137,1.137,0,0,1-1.137,1.137H24.644A1.137,1.137,0,0,1,23.508,43.9V36.693A1.136,1.136,0,0,1,24.644,35.556ZM32.97,37.83H25.781v4.932H32.97Zm-20.929,16a5.694,5.694,0,1,0,5.694-5.694,5.694,5.694,0,0,0-5.694,5.694Zm9.6,6.947a7.977,7.977,0,0,1-7.809,0,7.206,7.206,0,0,0-3.3,6.042v4.262h14.4V66.816A7.206,7.206,0,0,0,21.64,60.774Z"
          transform="translate(-8.26 -30.25)"
          fill="#fff"
        />
      </g>
    </g>,
  ],
});
export const DonationsIcon = createIcon({
  displayName: "DonationsIcon",
  viewBox: "0 0 90 90",
  path: [
    <defs>
      <clipPath id="clip-path">
        <rect width="90" height="90" fill="none" />
      </clipPath>
    </defs>,
    <g id="icon">
      <g
        id="Repeat_Grid_3"
        data-name="Repeat Grid 3"
        clip-path="url(#clip-path)"
      >
        <path
          id="Rectangle_2342"
          data-name="Rectangle 2342"
          d="M3,0H87a3,3,0,0,1,3,3V87a3,3,0,0,1-3,3h0A87,87,0,0,1,0,3V3A3,3,0,0,1,3,0Z"
          fill="#8ba58f"
          opacity="0.24"
        />
      </g>
      <path
        id="Rectangle_2343"
        data-name="Rectangle 2343"
        d="M3,0H3A87,87,0,0,1,90,87v0a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0Z"
        fill="currentColor"
      />
    </g>,
    <g
      id="Group_39583"
      data-name="Group 39583"
      transform="translate(-1017 -4478.615)"
    >
      <g id="Layer_x0020_1" transform="translate(1042 4498)">
        <path
          id="Path_19702"
          data-name="Path 19702"
          d="M38.234,10.3H71.853a1.184,1.184,0,0,1,1.185,1.184v4.958h7.149a1.184,1.184,0,0,1,1.184,1.184V56.505a1.184,1.184,0,0,1-1.184,1.184H46.567a1.185,1.185,0,0,1-1.185-1.184V51.547H38.234a1.184,1.184,0,0,1-1.184-1.184V11.484A1.184,1.184,0,0,1,38.234,10.3Zm34.8,8.511V50.363a1.185,1.185,0,0,1-1.185,1.184h-24.1v3.774H79V18.811H73.037ZM51.486,28.947a1.18,1.18,0,0,1-2.314-.462,5.992,5.992,0,0,1,2.461-3.742q-.088-.114-.168-.233a4.31,4.31,0,1,1,6.989.233,5.986,5.986,0,0,1,2.461,3.742,1.18,1.18,0,0,1-2.313.462,3.638,3.638,0,0,0-2.347-2.7,4.265,4.265,0,0,1-2.422,0A3.635,3.635,0,0,0,51.486,28.947Zm3.557-4.891A1.942,1.942,0,1,0,53.1,22.114,1.93,1.93,0,0,0,55.043,24.056Zm-8.69,11.41a1.184,1.184,0,0,1,0-2.369H63.734a1.184,1.184,0,0,1,0,2.369Zm0,8.576a1.184,1.184,0,0,1,0-2.369H63.734a1.184,1.184,0,0,1,0,2.369Zm0-4.288a1.184,1.184,0,0,1,0-2.369H63.734a1.184,1.184,0,0,1,0,2.369ZM70.668,12.669H39.419V49.178H70.668Z"
          transform="translate(-37.05 -10.3)"
          fill="#fff"
        />
      </g>
    </g>,
  ],
});
export const ProjectsIcon = createIcon({
  displayName: "projectsIcon",
  viewBox: "0 0 90 90",
  path: [
    <defs>
      <clipPath id="clip-path">
        <rect width="90" height="90" fill="none" />
      </clipPath>
    </defs>,
    <g id="icon">
      <g
        id="Repeat_Grid_3"
        data-name="Repeat Grid 3"
        clip-path="url(#clip-path)"
      >
        <path
          id="Rectangle_2342"
          data-name="Rectangle 2342"
          d="M3,0H87a3,3,0,0,1,3,3V87a3,3,0,0,1-3,3h0A87,87,0,0,1,0,3V3A3,3,0,0,1,3,0Z"
          fill="#8ba58f"
          opacity="0.24"
        />
      </g>
      <path
        id="Rectangle_2343"
        data-name="Rectangle 2343"
        d="M3,0H3A87,87,0,0,1,90,87v0a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0Z"
        fill="currentColor"
      />
    </g>,
    <g
      id="Group_39583"
      data-name="Group 39583"
      transform="translate(-1017 -4478.615)"
    >
      <g id="Layer_x0020_1" transform="translate(1010.06 4488.577)">
        <path
          id="Path_19705"
          data-name="Path 19705"
          d="M34.623,15.291h9.243V8.7a1.3,1.3,0,0,1,2.592,0v6.59H55.7a1.3,1.3,0,0,1,1.3,1.3V23.9h5.754v-6.59a1.3,1.3,0,0,1,2.592,0V23.9H72.4a1.3,1.3,0,0,1,1.3,1.3V56.649H76.8a1.3,1.3,0,0,1,0,2.592H30.218a1.3,1.3,0,0,1,0-2.592h3.108V16.587a1.3,1.3,0,0,1,1.3-1.3Zm26.7,20.338h5.449a1.3,1.3,0,0,1,1.3,1.3v8.662a1.3,1.3,0,0,1-1.3,1.3H61.324a1.3,1.3,0,0,1-1.3-1.3V36.925A1.3,1.3,0,0,1,61.324,35.629Zm4.153,2.592H62.62v6.071h2.857ZM40.341,24.668a1.3,1.3,0,0,1,0-2.592h9.641a1.3,1.3,0,0,1,0,2.592Zm0,4.471a1.3,1.3,0,0,1,0-2.592h9.641a1.3,1.3,0,0,1,0,2.592H40.341Zm7.394,27.51V45.233H42.589V56.649Zm-7.738,0V43.936a1.3,1.3,0,0,1,1.3-1.3h7.738a1.3,1.3,0,0,1,1.3,1.3V56.649h4.079V17.883H35.918V56.649ZM57,26.488V56.649H71.1V26.488Z"
          fill="#fff"
        />
      </g>
    </g>,
  ],
});
export const InitiativesIcon = createIcon({
  displayName: "InitiativesIcon",
  viewBox: "0 0 90 90",
  path: [
    <defs>
      <clipPath id="clip-path">
        <rect width="90" height="90" fill="none" />
      </clipPath>
    </defs>,
    <g id="icon">
      <g
        id="Repeat_Grid_3"
        data-name="Repeat Grid 3"
        clip-path="url(#clip-path)"
      >
        <path
          id="Rectangle_2342"
          data-name="Rectangle 2342"
          d="M3,0H87a3,3,0,0,1,3,3V87a3,3,0,0,1-3,3h0A87,87,0,0,1,0,3V3A3,3,0,0,1,3,0Z"
          fill="#8ba58f"
          opacity="0.24"
        />
      </g>
      <path
        id="Rectangle_2343"
        data-name="Rectangle 2343"
        d="M3,0H3A87,87,0,0,1,90,87v0a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0Z"
        fill="currentColor"
      />
    </g>,
    <g
      id="Group_39583"
      data-name="Group 39583"
      transform="translate(-1017 -4478.615)"
    >
      <g id="Layer_x0020_1" transform="translate(1029.096 4372.094)">
        <path
          id="Path_19703"
          data-name="Path 19703"
          d="M23.64,138.234l-3.787-3.546-9.666,10.992,3.4,3.227ZM35.5,164.727l5.567-3.787L35.5,156.815a1.374,1.374,0,0,1,1.636-2.207l6.342,4.695,3.067-2.086-4.988-3.423a1.375,1.375,0,0,1,1.55-2.272l5.879,4.034,1.313-.893.284-.642L43.148,147.1l-5.567.577a1.375,1.375,0,0,1-1.217-.436l-2.973-3.257L28.414,148.4a1.374,1.374,0,0,1-2-.046l-2.5-2.777a1.366,1.366,0,0,1-.319-.618l-.486-2.146-7.382,7.839ZM19.29,156.558l-.365,1.93,7.45,7.45,5.334-.539Zm17.024,10.937a1.372,1.372,0,0,1-.7.272l-9.515.96a1.375,1.375,0,0,1-1.218-.382l-8.419-8.423a1.375,1.375,0,0,1-.379-1.225l.736-3.895-3.945-2.808a1.377,1.377,0,0,1-.181-.145l-5.309-5.034a1.381,1.381,0,0,1-.144-1.961l11.479-13.044a1.37,1.37,0,0,1,1.966-.1l5.135,4.809,2.435-1.2a1.362,1.362,0,0,1,.608-.142l14.006,0,5.53-4.925a1.378,1.378,0,0,1,2.012.2l11.32,14.37a1.377,1.377,0,0,1-.346,2.014l-6.753,4.824-1.976,4.469a1.371,1.371,0,0,1-.577.64l-15.77,10.727ZM25.38,140.4,26.2,144l1.35,1.5,5.04-4.463a1.373,1.373,0,0,1,1.925.1l3.421,3.742,5.557-.577a1.373,1.373,0,0,1,1.076.361l7.195,6.7.195-.441-9.262-12.985H29.182L26.414,139.3Zm23.763-7.116-3.91,3.483,8.617,12.079,4.833-3.452Z"
          fill="#fff"
        />
      </g>
    </g>,
  ],
});
export const MembershipIcon = createIcon({
  displayName: "MembershipIcon",
  viewBox: "0 0 55 55",
  path: (
    <g id="Group_Membership" data-name="Group Membership">
      <rect width="55" height="55" rx="27.5" fill="currentColor" />
      <g transform="translate(3 3) scale(0.8)">
        <g fill="#fff">
          <circle cx="16" cy="14" r="5.5" />
          <path d="M7 27c0-3.5 2.5-5.5 5.5-5.5h7c3 0 5.5 2 5.5 5.5v2c0 1.2-0.8 2-2 2H9c-1.2 0-2-0.8-2-2v-2z" />
          <circle cx="33" cy="17" r="4" />
          <path d="M27 27.5c0-2.5 1.8-4 4-4h4c2.2 0 4 1.5 4 4v1.5c0 1-0.8 1.5-1.5 1.5h-9c-0.7 0-1.5-0.5-1.5-1.5v-1.5z" />
        </g>
        <g transform="translate(31 31)">
          <circle cx="10" cy="10" r="10" fill="#fff" />
          <path d="M10 4.5v11M4.5 10h11" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" />
        </g>
      </g>
    </g>
  ),
});

export const FastDonationIcon = createIcon({
  displayName: "FastDonationIcon",
  viewBox: "0 0 55 55",
  path: (
    <g
      id="Group_39455"
      data-name="Group 39455"
      transform="translate(9.185 7.072)"
    >
      <g id="icon" transform="translate(-9.185 -7.072)">
        <rect
          id="Rectangle_2343"
          data-name="Rectangle 2343"
          width="55"
          height="55"
          fill="currentColor"
        />
      </g>
      <g id="heart" transform="translate(4.816 6.457)">
        <g
          id="Group_39458"
          data-name="Group 39458"
          transform="translate(0 16.66)"
        >
          <g id="Group_39457" data-name="Group 39457" transform="translate(0)">
            <path
              id="Path_19655"
              data-name="Path 19655"
              d="M2.533,302H.845a.8.8,0,0,0-.791.806v9.67a.8.8,0,0,0,.791.806H2.533a2.4,2.4,0,0,0,2.374-2.417v-6.447A2.4,2.4,0,0,0,2.533,302Z"
              transform="translate(-0.054 -302)"
              fill="#fff"
            />
          </g>
        </g>
        <g
          id="Group_39460"
          data-name="Group 39460"
          transform="translate(6.435 16.351)"
        >
          <g id="Group_39459" data-name="Group 39459">
            <path
              id="Path_19656"
              data-name="Path 19656"
              d="M142.389,298.119a1.466,1.466,0,0,0-.364-.4,1.547,1.547,0,0,0-2.136.161L136.3,302.1l-.111.129a2.315,2.315,0,0,1-1.741.774h-6.139a.806.806,0,0,1,0-1.612h4.826a1.6,1.6,0,0,0,1.582-1.612v-.016a1.6,1.6,0,0,0-1.582-1.6h-2.864a2.155,2.155,0,0,1-1.392-.532,5.467,5.467,0,0,0-6.82-.371v9.912a17.952,17.952,0,0,0,4.81.661h7.057a5.512,5.512,0,0,0,4.431-2.256l3.8-5.157A2.167,2.167,0,0,0,142.389,298.119Z"
              transform="translate(-122.056 -296.246)"
              fill="#fff"
            />
          </g>
        </g>
        <g
          id="Group_39462"
          data-name="Group 39462"
          transform="translate(8.075)"
        >
          <g id="Group_39461" data-name="Group 39461">
            <path
              id="Path_19657"
              data-name="Path 19657"
              d="M115.047,1.558a4.458,4.458,0,0,0-7.15.512c-.071.1-.138.2-.2.3-.062-.1-.129-.2-.2-.3a4.458,4.458,0,0,0-7.15-.512,5.432,5.432,0,0,0-1.291,3.588,6.557,6.557,0,0,0,1.773,4.294,38.575,38.575,0,0,0,4.322,4.074c.648.557,1.318,1.133,2.029,1.761a.78.78,0,0,0,1.036,0c.712-.628,1.381-1.2,2.029-1.761,1.126-.968,2.1-1.8,2.941-2.614,1.638-1.574,3.153-3.36,3.153-5.754A5.431,5.431,0,0,0,115.047,1.558Z"
              transform="translate(-99.054 0)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </g>
  ),
});
export const WhatsappIcon = createIcon({
  displayName: "WhatsappIcon",
  viewBox: "0 0 54 54",
  path: (
    <g>
      <rect
        id="Rectangle_2343"
        data-name="Rectangle 2343"
        width="54"
        height="54"
        rx="27"
        fill="currentColor"
      />
      ,
      <path
        id="WhatsApp-Logo"
        d="M24.03,18.616c-.41-.205-2.426-1.2-2.8-1.334s-.649-.205-.923.205-1.059,1.334-1.3,1.608-.478.308-.888.1a11.2,11.2,0,0,1-3.3-2.035,12.358,12.358,0,0,1-2.281-2.841c-.239-.411-.026-.632.18-.837.185-.184.41-.479.615-.718a2.794,2.794,0,0,0,.41-.684.755.755,0,0,0-.034-.718c-.1-.205-.922-2.224-1.264-3.045-.333-.8-.671-.691-.923-.7s-.513-.014-.786-.014a1.507,1.507,0,0,0-1.094.513A4.6,4.6,0,0,0,8.21,11.535a7.976,7.976,0,0,0,1.674,4.242c.205.274,2.891,4.415,7,6.191a23.54,23.54,0,0,0,2.338.864,5.619,5.619,0,0,0,2.583.162,4.223,4.223,0,0,0,2.768-1.95,3.429,3.429,0,0,0,.239-1.95c-.1-.171-.376-.274-.786-.479M16.549,28.831h-.006A13.619,13.619,0,0,1,9.6,26.93l-.5-.3L3.94,27.989l1.378-5.033-.324-.516a13.64,13.64,0,1,1,11.555,6.392M28.157,3.583a16.414,16.414,0,0,0-25.829,19.8L0,31.887l8.7-2.282a16.4,16.4,0,0,0,7.842,2h.007A16.418,16.418,0,0,0,28.157,3.583"
        transform="translate(11.952 10.46)"
        fill="#fff"
        fillRule="evenodd"
      />
      ,
    </g>
  ),
});

export const GoalsIcon = createIcon({
  displayName: "GoalsIcon",
  viewBox: "0 0 32 32",
  path: (
    <g>
      <path
        fill="#8ba58f"
        opacity="0.24"
        d="M1.067 0h29.867c0.589 0 1.067 0.478 1.067 1.067v0 29.867c0 0.589-0.478 1.067-1.067 1.067v0 0c-17.084 0-30.933-13.849-30.933-30.933v0 0c0-0.589 0.478-1.067 1.067-1.067v0z"
      ></path>
      <path
        fill="currentColor"
        d="M1.067 0v0c17.084 0 30.933 13.849 30.933 30.933v0 0c0 0.589-0.478 1.067-1.067 1.067v0h-29.867c-0.589 0-1.067-0.478-1.067-1.067v0-29.867c0-0.589 0.478-1.067 1.067-1.067v0z"
      ></path>
      <path
        fill="#fff"
        d="M12.498 13.006l-0.559 0.559-0.13-0.13c-0.080-0.077-0.188-0.124-0.308-0.124-0.245 0-0.444 0.199-0.444 0.444 0 0.12 0.047 0.228 0.124 0.308l-0-0 0.444 0.444c0.080 0.080 0.191 0.13 0.314 0.13s0.234-0.050 0.314-0.13l0.873-0.873c0.084-0.081 0.136-0.194 0.136-0.32 0-0.245-0.199-0.444-0.444-0.444-0.126 0-0.239 0.052-0.32 0.136l-0 0z"
      ></path>
      <path
        fill="#fff"
        d="M14.159 14.223h2.665c0.245 0 0.444-0.199 0.444-0.444s-0.199-0.444-0.444-0.444v0h-2.665c-0.245 0-0.444 0.199-0.444 0.444s0.199 0.444 0.444 0.444v0z"
      ></path>
      <path
        fill="#fff"
        d="M12.498 15.7l-0.559 0.559-0.13-0.13c-0.081-0.084-0.194-0.136-0.32-0.136-0.245 0-0.444 0.199-0.444 0.444 0 0.126 0.052 0.239 0.136 0.32l0 0 0.444 0.444c0.080 0.080 0.191 0.13 0.314 0.13s0.234-0.050 0.314-0.13l0.873-0.873c0.084-0.081 0.136-0.194 0.136-0.32 0-0.245-0.199-0.444-0.444-0.444-0.126 0-0.239 0.052-0.32 0.136l-0 0z"
      ></path>
      <path
        fill="#fff"
        d="M12.498 18.352l-0.559 0.559-0.13-0.13c-0.080-0.077-0.188-0.124-0.308-0.124-0.245 0-0.444 0.199-0.444 0.444 0 0.119 0.047 0.228 0.124 0.308l-0-0 0.444 0.444c0.080 0.080 0.191 0.13 0.314 0.13s0.234-0.050 0.314-0.13l0.873-0.873c0.084-0.081 0.136-0.194 0.136-0.32 0-0.245-0.199-0.444-0.444-0.444-0.126 0-0.239 0.052-0.32 0.136l-0 0z"
      ></path>
      <path
        fill="#fff"
        d="M24.099 15.639l-1.045-0.348-0.348-1.045c-0.061-0.178-0.226-0.303-0.421-0.303-0.123 0-0.233 0.050-0.314 0.13v0l-1.255 1.255c-0.486-0.21-1.052-0.333-1.646-0.333-0.009 0-0.017 0-0.026 0h0.001v-3.879h0.889c0.245 0 0.444-0.199 0.444-0.444v0-0.681c-0.001-0.866-0.703-1.568-1.569-1.569h-7.993c-0.866 0.001-1.568 0.703-1.569 1.569v12.255c0 0.245 0.199 0.444 0.444 0.444v0h6.756c0.715 0.55 1.622 0.881 2.607 0.881 2.369 0 4.29-1.917 4.297-4.285v-0.001c0-0.003 0-0.006 0-0.009 0-0.595-0.122-1.161-0.343-1.675l0.011 0.028 1.255-1.255c0.080-0.080 0.13-0.191 0.13-0.314 0-0.195-0.126-0.361-0.3-0.42l-0.003-0.001zM19.058 20.765c-0 0-0 0-0 0-0.817 0-1.48-0.663-1.48-1.48s0.663-1.48 1.48-1.48c0.25 0 0.486 0.062 0.692 0.172l-0.008-0.004-0.998 0.998c-0.084 0.081-0.136 0.194-0.136 0.32 0 0.245 0.199 0.444 0.444 0.444 0.126 0 0.239-0.052 0.32-0.136l0-0 0.998-0.998c0.105 0.198 0.166 0.433 0.166 0.682 0 0.817-0.662 1.48-1.478 1.482h-0zM18.807 9.31c0.376 0 0.68 0.305 0.681 0.681v0.237h-7.105c0.004-0.045 0.006-0.098 0.006-0.151 0-0.277-0.060-0.541-0.167-0.778l0.005 0.012zM10.133 9.99c0-0.376 0.305-0.681 0.681-0.681s0.681 0.305 0.681 0.681v0 0.681c0 0 0 0 0 0 0 0.245 0.198 0.444 0.443 0.444h6.217v3.973c-0.717 0.158-1.343 0.476-1.863 0.916l0.006-0.005h-2.139c-0.245 0-0.444 0.199-0.444 0.444s0.199 0.444 0.444 0.444v0h1.339c-0.343 0.5-0.585 1.097-0.684 1.74l-0.003 0.024h-0.652c-0.245 0-0.444 0.199-0.444 0.444s0.199 0.444 0.444 0.444v0h0.613c0.051 0.855 0.347 1.633 0.818 2.274l-0.008-0.012h-5.448v-11.813zM19.058 22.689c-0 0-0.001 0-0.001 0-1.88 0-3.404-1.524-3.404-3.404s1.524-3.404 3.404-3.404c0.447 0 0.875 0.086 1.266 0.243l-0.023-0.008 0.323 0.975-0.237 0.237c-0.373-0.256-0.834-0.409-1.331-0.409-1.308 0-2.368 1.060-2.368 2.368s1.060 2.368 2.368 2.368c1.308 0 2.368-1.060 2.368-2.368 0-0.497-0.153-0.958-0.414-1.339l0.005 0.008 0.237-0.237 0.975 0.325c0.147 0.367 0.233 0.793 0.233 1.238 0 1.879-1.521 3.403-3.4 3.408h-0zM22.269 17.12l-0.785-0.262-0.262-0.785 0.868-0.868 0.191 0.574c0.045 0.133 0.148 0.236 0.278 0.28l0.003 0.001 0.574 0.191z"
      ></path>
    </g>
  ),
});

export const ValuesIcon = createIcon({
  displayName: "ValuesIcon",
  viewBox: "0 0 32 32",
  path: (
    <g>
      <path
        fill="#8ba58f"
        opacity="0.24"
        d="M1.067 0h29.867c0.589 0 1.067 0.478 1.067 1.067v0 29.867c0 0.589-0.478 1.067-1.067 1.067v0 0c-17.084 0-30.933-13.849-30.933-30.933v0 0c0-0.589 0.478-1.067 1.067-1.067v0z"
      ></path>
      <path
        fill="currentColor"
        d="M1.067 0v0c17.084 0 30.933 13.849 30.933 30.933v0 0c0 0.589-0.478 1.067-1.067 1.067v0h-29.867c-0.589 0-1.067-0.478-1.067-1.067v0-29.867c0-0.589 0.478-1.067 1.067-1.067v0z"
      ></path>
      <path
        fill="#fff"
        d="M25.773 13.124c-0.247-0.246-0.588-0.399-0.965-0.399s-0.718 0.152-0.965 0.399l-1.368 1.369v-3.603c0-0.001 0-0.003 0-0.004 0-0.375-0.153-0.715-0.399-0.96l-1.286-1.286c-0.245-0.247-0.585-0.4-0.961-0.4-0.001 0-0.002 0-0.004 0h-7.807c-0.753 0.001-1.363 0.611-1.364 1.364v12.791c0.001 0.753 0.611 1.363 1.364 1.364h9.093c0.753-0.001 1.363-0.611 1.364-1.364v-4.042l3.297-3.3c0.247-0.247 0.4-0.588 0.4-0.964s-0.153-0.718-0.4-0.964v0zM19.748 9.149c0.017-0.002 0.037-0.003 0.057-0.003 0.133 0 0.253 0.052 0.342 0.136l1.286 1.286c0.085 0.089 0.137 0.21 0.137 0.343 0 0.020-0.001 0.040-0.003 0.059l0-0.002h-1.819zM21.567 22.395c-0 0.251-0.204 0.455-0.455 0.455h-9.093c-0.251-0-0.455-0.204-0.455-0.455v-12.791c0-0.251 0.204-0.455 0.455-0.455h6.82v2.273c0 0.251 0.204 0.455 0.455 0.455v0h2.273v3.526l-1.984 1.985c-0.049 0.049-0.086 0.108-0.109 0.175l-0.001 0.003-0.643 1.929c-0.015 0.043-0.023 0.092-0.023 0.143 0 0.251 0.204 0.455 0.455 0.455 0.051 0 0.101-0.009 0.147-0.024l-0.003 0.001 1.929-0.643c0.070-0.024 0.129-0.061 0.178-0.11v0l0.055-0.055zM20.547 17.71l0.643 0.643-0.246 0.246-0.964 0.32 0.32-0.965zM21.833 17.71l-0.643-0.643 2.186-2.187 0.642 0.643zM25.13 14.411l-0.469 0.469-0.644-0.643 0.469-0.469c0.083-0.086 0.199-0.139 0.327-0.139 0.251 0 0.455 0.204 0.455 0.455 0 0.128-0.053 0.244-0.139 0.327l-0 0z"
      ></path>
      <path
        fill="#fff"
        d="M19.294 12.787h-6.364c-0.246 0.007-0.442 0.208-0.442 0.455s0.196 0.447 0.441 0.455h6.365c0.004 0 0.008 0 0.013 0 0.251 0 0.455-0.204 0.455-0.455s-0.204-0.455-0.455-0.455c-0.004 0-0.009 0-0.013 0h0.001z"
      ></path>
      <path
        fill="#fff"
        d="M17.475 14.605h-4.545c-0.004-0-0.008-0-0.013-0-0.251 0-0.455 0.204-0.455 0.455s0.204 0.455 0.455 0.455c0.004 0 0.009-0 0.013-0h4.545c0.004 0 0.008 0 0.013 0 0.251 0 0.455-0.204 0.455-0.455s-0.204-0.455-0.455-0.455c-0.004 0-0.009 0-0.013 0h0.001z"
      ></path>
      <path
        fill="#fff"
        d="M17.475 16.424h-4.545c-0.004-0-0.008-0-0.013-0-0.251 0-0.455 0.204-0.455 0.455s0.204 0.455 0.455 0.455c0.004 0 0.009-0 0.013-0h4.545c0.004 0 0.008 0 0.013 0 0.251 0 0.455-0.204 0.455-0.455s-0.204-0.455-0.455-0.455c-0.004 0-0.009 0-0.013 0h0.001z"
      ></path>
      <path
        fill="#fff"
        d="M17.475 18.243h-4.545c-0.004-0-0.008-0-0.013-0-0.251 0-0.455 0.204-0.455 0.455s0.204 0.455 0.455 0.455c0.004 0 0.009-0 0.013-0h4.545c0.004 0 0.008 0 0.013 0 0.251 0 0.455-0.204 0.455-0.455s-0.204-0.455-0.455-0.455c-0.004 0-0.009 0-0.013 0h0.001z"
      ></path>
    </g>
  ),
});

export const MsgIcon = createIcon({
  displayName: "MsgIcon",
  viewBox: "0 0 32 32",
  path: (
    <g>
      <path
        fill="#8ba58f"
        opacity="0.24"
        d="M1.067 0h29.867c0.589 0 1.067 0.478 1.067 1.067v0 29.867c0 0.589-0.478 1.067-1.067 1.067v0 0c-17.084 0-30.933-13.849-30.933-30.933v0 0c0-0.589 0.478-1.067 1.067-1.067v0z"
      ></path>
      <path
        fill="currentColor"
        d="M1.067 0v0c17.084 0 30.933 13.849 30.933 30.933v0 0c0 0.589-0.478 1.067-1.067 1.067v0h-29.867c-0.589 0-1.067-0.478-1.067-1.067v0-29.867c0-0.589 0.478-1.067 1.067-1.067v0z"
      ></path>
      <path
        fill="#fff"
        d="M21.538 10.849v-0.462c-0.001-0.703-0.57-1.272-1.272-1.273h-6.812c-0.703 0.001-1.272 0.57-1.273 1.273v0.429h-1.304c-1.17 0.001-2.118 0.95-2.118 2.12 0 0.002 0 0.004 0 0.006v-0 6.839c0.008 1.024 0.736 1.876 1.703 2.074l0.014 0.002v1.316c0.001 0.234 0.19 0.423 0.424 0.423h0c1.021-0.002 1.873-0.725 2.074-1.686l0.002-0.014 8.145-0.009c1.17-0.001 2.119-0.95 2.119-2.12 0-0.001 0-0.003 0-0.004v0-6.839c-0.008-1.019-0.729-1.868-1.688-2.071l-0.014-0.002zM19.841 10.387c0-0.234 0.19-0.424 0.424-0.424s0.424 0.19 0.424 0.424v0.425h-0.849zM13.030 10.387c0.001-0.234 0.19-0.423 0.424-0.424h5.612c-0.046 0.126-0.073 0.272-0.073 0.424 0 0 0 0 0 0.001v-0 8.514c0 0.234-0.19 0.424-0.424 0.424s-0.424-0.19-0.424-0.424v0-0.849c0 0 0 0 0 0 0-0.234-0.19-0.424-0.424-0.424-0 0-0.001 0-0.001 0h-4.689zM17.297 18.477v0.424c0 0 0 0 0 0.001 0 0.152 0.027 0.297 0.076 0.432l-0.003-0.009h-5.612c-0.234-0.001-0.423-0.19-0.424-0.424v-0.424zM22.393 19.764c0 0.001 0 0.002 0 0.003 0 0.702-0.569 1.272-1.271 1.272l-8.528 0.010c-0.234 0-0.424 0.19-0.424 0.425 0 0.001 0 0.002 0 0.002v-0c0 0 0 0.001 0 0.001 0 0.55-0.348 1.019-0.837 1.198l-0.009 0.003v-1.201c-0-0.234-0.19-0.424-0.425-0.424h-0.003c-0.001 0-0.002 0-0.003 0-0.704 0-1.277-0.567-1.286-1.269v-6.84c0-0.001 0-0.002 0-0.003 0-0.702 0.569-1.272 1.271-1.272h1.303v5.962h-1.273c-0.234 0-0.424 0.19-0.424 0.424v0.849c0.001 0.703 0.57 1.272 1.273 1.273h6.811c0.703-0.001 1.272-0.57 1.273-1.273v-7.241h1.273c0.021-0 0.042-0.002 0.062-0.005l-0.002 0c0.676 0.034 1.212 0.588 1.218 1.268v6.84z"
      ></path>
      <path
        fill="#fff"
        d="M14.303 12.537h3.394c0.234 0 0.424-0.19 0.424-0.424s-0.19-0.424-0.424-0.424v0h-3.394c-0.234 0-0.424 0.19-0.424 0.424s0.19 0.424 0.424 0.424v0z"
      ></path>
      <path
        fill="#fff"
        d="M14.303 14.234h3.394c0.234 0 0.424-0.19 0.424-0.424s-0.19-0.424-0.424-0.424v0h-3.394c-0.234 0-0.424 0.19-0.424 0.424s0.19 0.424 0.424 0.424v0z"
      ></path>
      <path
        fill="#fff"
        d="M14.303 15.931h1.697c0.234 0 0.424-0.19 0.424-0.424s-0.19-0.424-0.424-0.424v0h-1.697c-0.234 0-0.424 0.19-0.424 0.424s0.19 0.424 0.424 0.424v0z"
      ></path>
    </g>
  ),
});

export const UploadIcon = createIcon({
  displayName: "UploadIcon",
  viewBox: "0 0 39 32",
  path: (
    <g stroke="currentColor">
      <path
        strokeLinejoin="miter"
        strokeLinecap="butt"
        strokeMiterlimit="4"
        strokeWidth="0.654"
        d="M27.514 24.535c-1.679 0-3.375-0.018-5.054 0-0.344-0.012-0.62-0.288-0.632-0.631l-0-0.001c0.018-1.046 0.213-0.632 1.264-0.632 2.991 0 5.853 0.009 8.846 0 3.181-0.176 5.694-2.799 5.694-6.008 0-0.109-0.003-0.217-0.009-0.325l0.001 0.015c-0.034-2.372-1.602-4.368-3.755-5.044l-0.038-0.010c-0.315-0.074-0.558-0.317-0.631-0.626l-0.001-0.006c-0.434-2.919-2.922-5.133-5.928-5.133-0.361 0-0.714 0.032-1.058 0.093l0.036-0.005c-1.105 0.162-2.269-0.042-3.159 0.632-0.269 0.197-0.523 0.269-0.632 0-1.299-3.007-4.238-5.073-7.66-5.073-0.195 0-0.388 0.007-0.58 0.020l0.026-0.001c-4.273 0.124-7.747 3.381-8.211 7.548l-0.003 0.038c-0.049 0.285-0.077 0.613-0.077 0.948s0.028 0.663 0.082 0.982l-0.005-0.034c0.054 0.297 0.251 0.551 0 0.632-2.488 0.775-4.287 2.999-4.419 5.662l-0.001 0.015c0.007 3.138 2.548 5.68 5.685 5.687h0.001c3.207 0.018 6.271 0.018 9.478 0 0.023-0.003 0.049-0.005 0.076-0.005 0.31 0 0.561 0.251 0.561 0.561 0 0.027-0.002 0.053-0.005 0.079l0-0.003c-0.027 0.925 0.302 0.632-0.632 0.632h-8.846c-0.084 0.003-0.182 0.005-0.28 0.005-4.038 0-7.312-3.274-7.312-7.312 0-0.099 0.002-0.197 0.006-0.294l-0 0.014c0.075-2.525 1.592-4.678 3.753-5.669l0.040-0.017c0.262-0.131 0.632-0.327 0.632-0.632-0.006-0.127-0.009-0.275-0.009-0.425 0-4.858 3.531-8.891 8.167-9.673l0.058-0.008c0.508-0.091 1.092-0.143 1.688-0.143 3.511 0 6.601 1.8 8.398 4.527l0.023 0.038c0.242 0.377 0.209 0.17 0.632 0 0.819-0.298 1.765-0.471 2.75-0.471 3.815 0 7.026 2.585 7.977 6.099l0.013 0.058c0.072 0.279 0.362-0.131 0.632 0 2.322 1.3 3.866 3.744 3.866 6.548 0 0.366-0.026 0.726-0.077 1.078l0.005-0.040c-0.279 3.163-2.61 5.709-5.641 6.31l-0.045 0.007c-0.284 0.032-0.614 0.051-0.948 0.051s-0.663-0.018-0.988-0.054l0.040 0.004c-1.266-0.009-2.536-0.009-3.794-0.009z"
      ></path>
      <path
        strokeLinejoin="miter"
        strokeLinecap="butt"
        strokeMiterlimit="4"
        strokeWidth="0.654"
        d="M19.301 15.697c-1.5 1.509-3.040 3.008-4.422 4.422-0.279 0.279-0.344 0.314-0.632 0-0.71-0.764-0.727-0.536 0-1.264 1.806-1.806 3.249-3.863 5.054-5.686 0.225-0.225 0.362-0.269 0.632 0 1.962 1.986 4.341 4.36 6.318 6.318 0.216 0.216 0.251-0.207 0 0-0.28 0.117-0.606 0.185-0.948 0.185s-0.667-0.068-0.964-0.191l0.017 0.006c-1.159-1.15-2.009-2.009-3.159-3.159l-0.632-0.632c-0.131 0.17 0 0.479 0 0.632 0 4.905-0.018 10.259 0 15.164 0 0.404-0.218 0.018-0.632 0-0.934-0.027-0.632 0.293-0.632-0.632v-14.532c-0.018-0.12 0-0.327 0-0.632z"
      ></path>
    </g>
  ),
});

export const PdfIcon = createIcon({
  displayName: "PdfIcon",
  viewBox: "0 0 28 32",
  path: (
    <g fill="currentColor">
      <path
        opacity="0.11"
        d="M3.556 0h21.333c1.964 0 3.556 1.592 3.556 3.556v24.889c0 1.964-1.592 3.556-3.556 3.556h-21.333c-1.964 0-3.556-1.592-3.556-3.556v-24.889c0-1.964 1.592-3.556 3.556-3.556z"
      />
      <path d="M8.683 14.003h-1.37c0 0 0 0 0 0-0.358 0-0.648 0.29-0.648 0.648 0 0.001 0 0.002 0 0.002v-0l0.009 4.921c0 0.358 0.29 0.648 0.648 0.648s0.648-0.29 0.648-0.648v0-1.493h0.711c0.011 0 0.025 0 0.038 0 1.125 0 2.037-0.912 2.037-2.037s-0.912-2.037-2.037-2.037c-0.013 0-0.027 0-0.040 0l0.002-0zM8.683 16.782h-0.717c0-0.276 0-0.572 0-0.744 0-0.146 0-0.453 0-0.742h0.721c0.007-0 0.015-0 0.023-0 0.41 0 0.742 0.332 0.742 0.742s-0.332 0.742-0.742 0.742c-0.008 0-0.016-0-0.024-0l0.001 0z"></path>
      <path d="M14.194 14.003h-1.351c0 0 0 0 0 0-0.358 0-0.648 0.29-0.648 0.648 0 0.001 0 0.001 0 0.002v-0s0.010 4.764 0.010 4.778c0.001 0.357 0.291 0.646 0.648 0.646 0 0 0 0 0 0v0c0.041 0 1.006-0.004 1.392-0.011 1.463-0.026 2.526-1.298 2.526-3.026 0-1.816-1.035-3.036-2.576-3.036zM14.222 18.768c-0.168 0-0.457 0.005-0.726 0.007 0-0.563-0.006-2.893-0.006-3.478h0.704c1.189 0 1.28 1.333 1.28 1.741 0.001 0.853-0.386 1.717-1.252 1.73z"></path>
      <path d="M21.043 15.249c0.358 0 0.648-0.29 0.648-0.648s-0.29-0.648-0.648-0.648h-1.98c-0.358 0-0.648 0.29-0.648 0.648v0 4.887c0 0.358 0.29 0.648 0.648 0.648s0.648-0.29 0.648-0.648v-1.842h1.175c0.358 0 0.648-0.29 0.648-0.648s-0.29-0.648-0.648-0.648h-1.175v-1.101z"></path>
      <path d="M22.945 11.24h-0.474v-0.185c0-0.001 0-0.003 0-0.005 0-0.863-0.339-1.646-0.89-2.225l0.001 0.001-2.691-2.838c-0.592-0.622-1.426-1.009-2.35-1.011h-8.624c-1.073 0.001-1.943 0.87-1.944 1.943v4.319h-0.475c-1.072 0.002-1.941 0.87-1.943 1.943v7.774c0.002 1.072 0.871 1.94 1.943 1.941h0.474v2.247c0.001 1.073 0.871 1.942 1.943 1.943h12.61c1.073-0.001 1.943-0.87 1.944-1.943v-2.247h0.475c1.072-0.002 1.94-0.87 1.943-1.941v-7.774c-0.002-1.073-0.871-1.942-1.943-1.943h-0zM7.27 6.921c0-0.358 0.29-0.647 0.648-0.648h8.624c0.555 0.001 1.055 0.234 1.409 0.606l0.001 0.001 2.691 2.838c0.33 0.347 0.533 0.817 0.533 1.334 0 0.001 0 0.002 0 0.003v-0 0.185h-13.906zM21.175 25.145c-0 0.358-0.29 0.647-0.648 0.648h-12.609c-0.358-0-0.647-0.29-0.648-0.648v-2.247h13.905zM23.593 20.956c-0 0.358-0.29 0.647-0.648 0.648h-17.446c-0.358-0-0.647-0.29-0.648-0.648v-7.773c0-0.358 0.29-0.647 0.648-0.648h17.446c0.358 0 0.647 0.29 0.648 0.648v0z"></path>
    </g>
  ),
});
